module.exports = __webpack_public_path__ + "img/Denmark.25f4c122.svg";